import { useMediaQuery } from '@vueuse/core'
import type { Ref } from 'vue'

export const useTouchDevice = (): Ref<boolean> => useMediaQuery('(any-hover: none)')
